// Vue
import {Vue, Component, Prop, Watch} from 'vue-property-decorator'

// Template
import template from './template.vue'

@Component({
    name: 'Tooltip',
    mixins: [
        template,
    ]
})
export class Tooltip extends Vue {

    public get positionClass() {
        return `${this.$appPrefix}-tooltip--${this.position}`
    }

    public get visibleClass() {
        return this.isVisible ? `${this.$appPrefix}-tooltip--visible` : ''
    }

    public isVisible: boolean = false
    public position: string = 'right'

    public $el!: HTMLElement
    public $parent!: Vue & {$el: HTMLElement}

    @Prop({default: 'default'})
    public theme!: string

    @Prop()
    public width!: string

    public created() {

    }

    public getParent() {
        let parent = this.$parent;
        if (parent['getRealParent']) {
            parent = parent['getRealParent']();
        }

        return parent
    }

    public mounted () {
        let parent = this.getParent()
        parent.$el.addEventListener('mouseenter', this.handleParentMouseEnter)
        parent.$el.addEventListener('mouseleave', this.handleParentMouseLeave)
        
        // Set initial position
        this.handleDecisionPositionTooltip()

        this.$nextTick(() => {
            parent.$el.style.position = 'relative'
        })
    }

    public destroyed() {
        let parent = this.getParent()
        parent.$el.removeEventListener('mouseenter', this.handleParentMouseEnter)
        parent.$el.removeEventListener('mouseleave', this.handleParentMouseLeave)
    }

    public handleParentMouseEnter(e: Event) {

        this.handleDecisionPositionTooltip()

        this.isVisible = true
    }

    public handleParentMouseLeave(e: Event) {

        this.isVisible = false
    }

    public handleDecisionPositionTooltip() {

        let offsetTop = 0
        const headerElement = <HTMLElement>document.querySelector(`.${this.$appPrefix}-header`)
        const navigatioBarElement = <HTMLElement>document.querySelector(`.${this.$appPrefix}-navigation-bar`)

        if (headerElement  && headerElement.classList.contains(`${this.$appPrefix}-header--sticky`)) offsetTop += headerElement.offsetHeight
        if (navigatioBarElement && navigatioBarElement.classList.contains(`${this.$appPrefix}-navigation-bar--sticky`)) offsetTop += navigatioBarElement.offsetHeight

        const fixedFooterElement = <HTMLElement>document.querySelector(`.${this.$appPrefix}-fixed-footer`)

        let offsetBottom = 0;

        if (fixedFooterElement) {
            offsetBottom += fixedFooterElement.offsetHeight
        }

        let parent = this.getParent()
        if ((window.innerWidth - parent.$el.getBoundingClientRect().right) > (this.$el.offsetWidth + 10) && 
            ((fixedFooterElement && fixedFooterElement.contains(this.$el)) ||
            ((window.innerHeight - parent.$el.getBoundingClientRect().bottom + (parent.$el.offsetHeight / 2) - (this.$el.offsetHeight / 2)) > offsetBottom &&
            (window.innerHeight - parent.$el.getBoundingClientRect().top) > 0))) {
            this.position = 'right'
        } else if (parent.$el.getBoundingClientRect().left > (this.$el.offsetWidth + 10) && 
                    ((fixedFooterElement && fixedFooterElement.contains(this.$el)) ||
                    ((window.innerHeight - parent.$el.getBoundingClientRect().bottom + (parent.$el.offsetHeight / 2) - (this.$el.offsetHeight / 2)) > offsetBottom &&
                    (window.innerHeight - parent.$el.getBoundingClientRect().top) > 0))) {
            this.position = 'left'
        } else if ((parent.$el.getBoundingClientRect().top - offsetTop) > (this.$el.offsetHeight + 10)) {
            this.position = 'top'
        } else {
            this.position = 'bottom'
        }
    }
}